import React from "react";
import { Box, Typography, Dialog, IconButton } from "@mui/material";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import CloseIcon from "@mui/icons-material/Close";
import welcomeImage from "../../assets/images/waving-hand.png"

const NewLibrary = ({ openPopup, handleClose, openAddLibrary }) => {

  const empName = localStorage.getItem('employeeName') || '';

  return (
    <Dialog
      open={openPopup}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "35%",
          height: "300px",
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          p: 4,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "relative"
        }}
      >

        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, display:'flex',alignItems:'center', gap :"6px"}}>
             <span><img alt="" src={welcomeImage } /> </span>
          Welcome <span style={{color:"#0000ff"}}>{empName}</span>
        </Typography>

        <Typography variant="body1" sx={{ mb: 5, color: "text.secondary" }}>
          No libraries yet! Create
        </Typography>

        <Box
          onClick={openAddLibrary}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            cursor: "pointer",
            border: "2px solid #228b22",
            borderRadius: 3,
            p: 2,
            justifyContent: "center",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#f5f9ff",
            }
          }}
        >
          <LibraryAddIcon />
          <Typography fontWeight="bold">
            Create
          </Typography>
        </Box>

      </Box>
    </Dialog>
  );
};

export default NewLibrary;